<template>
  <card-modal>
    <template v-slot:header>
      <span
        class="title-modal-card"
        v-text="$t('general.login') + ' / ' + $t('general.sign_up')"
      />
      <v-spacer></v-spacer>
      <v-btn icon x-large @click="$emit('input', false)">
        <v-icon x-large color="primary" v-text="'mdi-close'" />
      </v-btn>
    </template>
    <template v-slot:body>
      <v-tabs-items v-model="tab" style="width: 100%">
        <v-tab-item :key="0">
          <v-container v-show="action == 'Activate'" mt-5>
            <v-row no-gutters justify="center">
              <v-col cols="12" class="text-center mb-4">
                <h2 v-text="$t('inputs.activation_code')" />
                <span v-text="$t('general.activation_message')" />
              </v-col>
              <CodeInput
                ref="activationInput"
                :fields="4"
                :auto-focus="false"
                :loading="$store.getters.isLoading"
                class="input"
                @complete="activateCustomer"
              />
              <!--              <v-container fluid>-->
              <!--                <v-row justify="end" class="mx-2">-->
              <!--                  <a>-->
              <!--                    <span v-text="'Resend the code'" />-->
              <!--                  </a>-->
              <!--                </v-row>-->
              <!--              </v-container>-->
            </v-row>
          </v-container>
          <v-form
            v-show="action != 'Activate'"
            ref="FormLogin"
            v-model="validLogin"
            :disabled="$store.getters.isLoading"
            class="pt-7"
          >
            <v-row no-gutters justify="center" class="test_red">
              <v-col cols="12">
                <vue-tel-input-vuetify
                  v-model="phoneNumberLogin"
                  label="Phone number"
                  clearable
                  :default-country="country"
                  type="tel"
                  :input-options="{
                    showDialCode: true,
                    tabindex: 0,
                  }"
                  mode="international"
                  :rules="[
                    $rules.required,
                    $rules.phoneNumber(phoneLoginValid),
                  ]"
                  :valid-characters-only="true"
                  @input="onInputPhoneLogin"
                />
              </v-col>
              <v-col v-if="action == 'Login'" cols="12">
                <v-text-field
                  v-model="formLogin.password"
                  :append-icon="showLogin ? 'mdi-eye' : 'mdi-eye-off'"
                  class="inputs-default"
                  :label="$t('inputs.password')"
                  :type="showLogin ? 'text' : 'password'"
                  :rules="[$rules.required, $rules.minPassword]"
                  @click:append="showLogin = !showLogin"
                  @keyup.enter.native="login()"
                />
              </v-col>
              <v-col v-if="action == 'Login'" cols="12">
                <v-container fluid>
                  <v-row justify="end" class="mx-2">
                    <a @click="tab = 2">
                      <span v-text="'forgot password'" />
                    </a>
                  </v-row>
                </v-container>
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>
        <v-tab-item :key="1">
          <v-form
            ref="FormRegistration"
            v-model="validRegistration"
            :disabled="$store.getters.isLoading"
            class="pt-7"
          >
            <v-row no-gutters justify="center">
              <v-col cols="12">
                <v-text-field
                  v-model="formRegistration.firstName"
                  :label="$t('inputs.first_name')"
                  clearable
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="formRegistration.lastName"
                  :label="$t('inputs.last_name')"
                  clearable
                  :rules="[$rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="formRegistration.email"
                  :label="$t('inputs.email')"
                  clearable
                  type="email"
                  inputmode="email"
                  :rules="[$rules.required, $rules.email]"
                />
              </v-col>
              <v-col cols="12">
                <vue-tel-input-vuetify
                  ref="phoneReister"
                  v-model="phoneNumberRegistration"
                  label="Phone number"
                  :default-country="country"
                  type="tel"
                  :input-options="{
                    showDialCode: true,
                    tabindex: 0,
                  }"
                  mode="international"
                  :rules="[
                    $rules.required,
                    $rules.phoneNumber(phoneRegisterValid),
                  ]"
                  :valid-characters-only="true"
                  @input="onInputRegisterLogin"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="formRegistration.password"
                  :append-icon="showRegistration ? 'mdi-eye' : 'mdi-eye-off'"
                  class="inputs-default"
                  :label="$t('inputs.new_password')"
                  :type="showRegistration ? 'text' : 'password'"
                  :rules="[$rules.required, $rules.minPassword]"
                  @click:append="showRegistration = !showRegistration"
                />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="formRegistration.repeatPassword"
                  class="inputs-default"
                  :label="$t('inputs.repeat_new_password')"
                  :type="showRegistration ? 'text' : 'password'"
                  :rules="[
                    $rules.required,
                    $rules.repeatPasswordRules(
                      formRegistration.repeatPassword,
                      formRegistration.password
                    ),
                  ]"
                  @keyup.enter.native="login()"
                />
              </v-col>
            </v-row>
          </v-form>
        </v-tab-item>
        <v-tab-item :key="2">
          <v-form
            ref="FormResetPassword"
            v-model="validResetPassword"
            :disabled="$store.getters.isLoading"
            class="pt-7"
          >
            <v-col cols="12">
              <v-text-field
                v-model="formReset.email"
                :label="$t('inputs.email')"
                clearable
                type="email"
                inputmode="email"
                :rules="[$rules.required, $rules.email]"
              />
            </v-col>
          </v-form>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <template v-slot:actions>
      <v-col v-if="tab === 0">
        <ButtonSuccess
          v-if="action != 'Activate'"
          :valid="validLogin"
          @click="action == 'Login' ? login() : checkPhone()"
        />
      </v-col>
      <v-col v-else-if="tab === 2">
        <ButtonSuccess
          :title="'general.send_email'"
          :valid="validResetPassword"
          @click="forgotPassword()"
        />
      </v-col>
      <v-col v-else>
        <ButtonSuccess :valid="validRegistration" @click="registerUser()" />
      </v-col>
    </template>
  </card-modal>
</template>

<script>
import CodeInput from "vue-verification-code-input";
export default {
  name: "ModalAuthForm",
  components: {
    CodeInput,
  },
  data: () => ({
    country: "DK",
    showLogin: false,
    validLogin: false,
    action: null,
    tab: 0,
    phoneNumberLogin: "",
    formLogin: new Form({
      phone: "",
      password: "",
      isApp: "0",
    }),
    showRegistration: false,
    validRegistration: false,
    phoneNumberRegistration: "",
    formRegistration: new Form({
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      password: "",
      repeatPassword: "",
    }),
    validResetPassword: false,
    formReset: new Form({
      email: "",
    }),
    phoneLoginValid: false,
    phoneRegisterValid: false,
  }),
  watch: {
    phoneNumberLogin: function () {
      this.formLogin.phone = this.phoneNumberLogin.replace(/\s/g, "");
    },
    phoneNumberRegistration: function () {
      this.formRegistration.phone = this.phoneNumberRegistration.replace(
        /\s/g,
        ""
      );
    },
  },
  methods: {
    checkPhone: async function () {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await self.formLogin.get("/app/check/user");
      self.action = data.data.action;
      if (self.action == "Register") {
        self.tab = 1;
        setTimeout(() => {
          self.phoneNumberRegistration = self.phoneNumberLogin;
          self.focus = false;
        }, 500);
      } else {
        self.tab = 0;
        setTimeout(() => {
          self.focusActiveCode();
        }, 500);
      }

      self.$store.dispatch("loading/done");
    },
    login: async function () {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await self.formLogin.post("/app/login");
      // Save the token.
      self.$store.dispatch("auth/setToken", {
        token: data.data.token,
      });
      await this.$store.dispatch("auth/fetchUser");
      // Redirect Dashboard.
      self.redirect();
    },
    registerUser: async function () {
      this.$emit("cleanPaymentInfo");
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await self.formRegistration.post(
        "/app/register/customer"
      );
      Toast.fire({
        icon: "success",
        title: data.message,
      });

      self.tab = 0;
      self.action = "Activate";
      self.phoneNumberRegistration = "";
      self.formRegistration = new Form({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        password: "",
        repeatPassword: "",
      });
      self.$store.dispatch("loading/done");
    },
    activateCustomer: async function (v) {
      const self = this;
      self.$store.dispatch("loading/start");
      let form = new Form({
        phone: self.formLogin.phone,
        activationCode: v,
      });
      self.$refs.activationInput.values = ["", "", "", ""];

      self.focusActiveCode();
      const { data } = await form.post("/app/activate/customer");
      Toast.fire({
        icon: "success",
        title: data.message,
      });

      self.action = null;
      self.$store.dispatch("loading/done");
    },
    focusActiveCode: async function () {
      document.querySelectorAll('[data-id="' + 0 + '"]')[0].focus();
    },
    redirect: async function () {
      if (this.$store.getters.user.role == "Admin") {
        this.$router.push({ name: "Dashboard" });
      } else {
        this.$emit("input", false);
      }

      setTimeout(() => {
        this.$store.dispatch("loading/done");
      }, 500);
    },
    forgotPassword: async function () {
      const self = this;
      self.$store.dispatch("loading/start");
      const { data } = await self.formReset.post("/app/forgot/password");
      Toast.fire({
        icon: "success",
        title: data.message,
      });
      self.tab = 0;
      self.$store.dispatch("loading/done");
    },
    onInputPhoneLogin(formattedNumber, { valid }) {
      this.phoneLoginValid = valid;
    },
    onInputRegisterLogin(formattedNumber, { valid }) {
      this.phoneRegisterValid = valid;
    },
  },
};
</script>
<style lang="scss" scoped>
.text-tab {
  font-size: 1.2rem !important;
  font-family: $font_Bold;
}
</style>
